export default __webpack_public_path__ + "static/media/portadavideoseguimiento5.9a14e378.png";